"use client";

import { c as _c } from "react/compiler-runtime";
import { Progress, ProgressColor } from "@workspace/ui/components";
import { ProductPage as ProductPageComponent, ShopAvailabilityDrawer, SizeTableDrawer } from "@workspace/ui/widgets";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { useCart, useCategory, useShopAvailability } from "@/context";
import { addToCartEvent, calculateValue, viewItemEvent } from "@/dataLayer";
import { useFacebookPixel } from "@/hooks/useFacebookPixel";
export default function ProductView(t0) {
  const $ = _c(136);
  const {
    params
  } = t0;
  const [isGTagEventSent, setIsGTagEventSent] = useState(false);
  const [isFBPixelEventSent, setIsFBPixelEventSent] = useState(false);
  const [loadedProduct, setLoadedProduct] = useState(false);
  const [hasInitialProductLoaded, setHasInitialProductLoaded] = useState(false);
  const [openShopAvailabilityDrawer, setOpenShopAvailabilityDrawer] = useState(false);
  const [openSizeTableDrawer, setOpenSizeTableDrawer] = useState(false);
  const {
    state: t1,
    getProductData,
    getFeaturedProducts,
    clearProductData
  } = useCategory();
  const {
    product,
    loadingProduct,
    featuredProducts,
    loadingFeaturedProducts,
    accessories
  } = t1;
  const {
    state: t2,
    updateCart,
    toggleUpdateCartModal
  } = useCart();
  const {
    openUpdateCartModal,
    addedProduct
  } = t2;
  const {
    state: t3,
    setShopAvailability,
    selectColor,
    selectSize,
    searchAvailabilityFunc,
    clearSearch
  } = useShopAvailability();
  const {
    combinations,
    attributes,
    selectedColor,
    selectedSize,
    searchedAvailability,
    searchedShops,
    selectedReference,
    searchAvailabilityLoading
  } = t3;
  const {
    trackViewContent,
    trackAddToCart
  } = useFacebookPixel();
  const pathname = usePathname();
  let t4;
  if ($[0] !== product || $[1] !== trackAddToCart || $[2] !== updateCart) {
    t4 = (idProduct, idProductAttribute, qty, op) => {
      if (op === "up" && product) {
        addToCartEvent({
          item: {
            index: Number(product.id) || 0,
            item_name: product.name || "",
            item_id: product.reference || "",
            item_brand: "Carry",
            item_category: product.categoryInfo?.name || "",
            item_variant: product.color || "",
            price: calculateValue(product.price.toString() || "0", "0", true),
            quantity: qty
          },
          value: calculateValue(product.price.toString() || "0", "0", true),
          currency: "PLN"
        });
        const numericPrice = parseFloat(product.price?.replace(/[^\d,]/g, "").replace(",", ".") || "0");
        const contentIds = product.reference || product.id?.toString() || "";
        trackAddToCart([contentIds], numericPrice * qty, "PLN");
      }
      return updateCart(idProduct, idProductAttribute, qty, op);
    };
    $[0] = product;
    $[1] = trackAddToCart;
    $[2] = updateCart;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const updateCartWithGTM = t4;
  const extractReferenceFromUrl = _temp;
  let t5;
  let t6;
  if ($[4] !== isGTagEventSent || $[5] !== product) {
    t5 = () => {
      if (isGTagEventSent || !product) {
        return;
      }
      viewItemEvent({
        item: {
          index: Number(product.id) || 0,
          item_name: product.name || "",
          item_id: product.reference || "",
          item_brand: "Carry",
          item_category: product.categoryInfo?.name || "",
          item_variant: product.color || "",
          price: calculateValue(product.price.toString() || "0", "0", true),
          quantity: 1
        },
        value: calculateValue(product.price.toString() || "0", "0", true),
        currency: "PLN"
      });
      setIsGTagEventSent(true);
    };
    t6 = [isGTagEventSent, product];
    $[4] = isGTagEventSent;
    $[5] = product;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[8] !== isFBPixelEventSent || $[9] !== product || $[10] !== trackViewContent) {
    t7 = () => {
      if (isFBPixelEventSent || !product) {
        return;
      }
      const numericPrice_0 = parseFloat(product.price?.replace(/[^\d,]/g, "").replace(",", ".") || "0");
      const contentIds_0 = product.reference || product.id?.toString() || "";
      trackViewContent(contentIds_0, numericPrice_0);
      setIsFBPixelEventSent(true);
    };
    t8 = [isFBPixelEventSent, product, trackViewContent];
    $[8] = isFBPixelEventSent;
    $[9] = product;
    $[10] = trackViewContent;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== getFeaturedProducts || $[14] !== getProductData || $[15] !== loadedProduct || $[16] !== params || $[17] !== setShopAvailability) {
    t9 = () => {
      if (loadedProduct) {
        return;
      }
      params.then(resolvedParams => {
        const reference = extractReferenceFromUrl(resolvedParams.productSlug);
        if (reference) {
          getProductData(reference).then(response => {
            if (response?.combinations && response?.attributes) {
              setShopAvailability(response.combinations, response.attributes);
            }
            getFeaturedProducts(response?.idProduct);
          });
          setLoadedProduct(true);
        }
      });
    };
    $[13] = getFeaturedProducts;
    $[14] = getProductData;
    $[15] = loadedProduct;
    $[16] = params;
    $[17] = setShopAvailability;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== params) {
    t10 = [params];
    $[19] = params;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[21] !== hasInitialProductLoaded || $[22] !== product) {
    t11 = () => {
      if (product && !hasInitialProductLoaded) {
        setHasInitialProductLoaded(true);
      }
    };
    t12 = [hasInitialProductLoaded, product];
    $[21] = hasInitialProductLoaded;
    $[22] = product;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] !== clearProductData) {
    t13 = () => () => {
      clearProductData();
    };
    $[25] = clearProductData;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [];
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  useEffect(t13, t14);
  if (!hasInitialProductLoaded && (loadingProduct || !product)) {
    let t15;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <div className="flex items-center justify-center min-h-[calc(100vh-500px)]"><Progress color={ProgressColor.GRAYSCALE_400} /></div>;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    return t15;
  }
  if (!product) {
    return null;
  }
  let t15;
  if ($[29] !== product.name) {
    t15 = <meta itemProp="name" content={product.name} />;
    $[29] = product.name;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== product.id) {
    t16 = product.id?.toString();
    $[31] = product.id;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <meta itemProp="productID" content={t16} />;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  let t19;
  if ($[35] !== product.reference) {
    t18 = <meta itemProp="sku" content={product.reference} />;
    t19 = <meta itemProp="mpn" content={product.reference} />;
    $[35] = product.reference;
    $[36] = t18;
    $[37] = t19;
  } else {
    t18 = $[36];
    t19 = $[37];
  }
  const t20 = `https://www.carry.pl/${product.parentCategory?.linkRewrite}/${product.url}`;
  let t21;
  if ($[38] !== t20) {
    t21 = <meta itemProp="url" content={t20} />;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== product.description) {
    t22 = product.description?.replace(/<[^>]*>/g, "") || "";
    $[40] = product.description;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t22) {
    t23 = <meta itemProp="description" content={t22} />;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== product.descriptionShort) {
    t24 = product.descriptionShort && <meta itemProp="disambiguatingDescription" content={product.descriptionShort} />;
    $[44] = product.descriptionShort;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== product.categoryInfo) {
    t25 = product.categoryInfo?.name && <meta itemProp="category" content={product.categoryInfo.name} />;
    $[46] = product.categoryInfo;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== product.color) {
    t26 = product.color && <meta itemProp="color" content={product.color} />;
    $[48] = product.color;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== product.descriptionShort) {
    t27 = product.descriptionShort && <meta itemProp="material" content={product.descriptionShort} />;
    $[50] = product.descriptionShort;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== product.cover) {
    t28 = product.cover?.large?.url && <meta itemProp="image" content={product.cover.large.url} />;
    $[52] = product.cover;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== product.price) {
    t29 = product.price?.replace(/[^\d,]/g, "").replace(",", ".");
    $[54] = product.price;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t29) {
    t30 = <meta itemProp="price" content={t29} />;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <meta itemProp="priceCurrency" content="PLN" />;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  const t32 = product?.quantity && product.quantity > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock";
  let t33;
  if ($[59] !== t32) {
    t33 = <meta itemProp="availability" content={t32} />;
    $[59] = t32;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = new Date(Date.now() + 2592000000).toISOString().split("T");
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t34[0]) {
    t35 = <meta itemProp="priceValidUntil" content={t34[0]} />;
    $[62] = t34[0];
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  const t36 = `https://www.carry.pl/${product.parentCategory?.linkRewrite}/${product.url}`;
  let t37;
  if ($[64] !== t36) {
    t37 = <meta itemProp="url" content={t36} />;
    $[64] = t36;
    $[65] = t37;
  } else {
    t37 = $[65];
  }
  let t38;
  let t39;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div itemProp="seller" itemScope={true} itemType="https://schema.org/Organization"><meta itemProp="name" content="Carry" /><meta itemProp="url" content="https://www.carry.pl" /></div>;
    t39 = <meta itemProp="itemCondition" content="https://schema.org/NewCondition" />;
    $[66] = t38;
    $[67] = t39;
  } else {
    t38 = $[66];
    t39 = $[67];
  }
  let t40;
  if ($[68] !== t30 || $[69] !== t33 || $[70] !== t35 || $[71] !== t37) {
    t40 = <div itemProp="offers" itemScope={true} itemType="https://schema.org/Offer">{t30}{t31}{t33}{t35}{t37}{t38}{t39}</div>;
    $[68] = t30;
    $[69] = t33;
    $[70] = t35;
    $[71] = t37;
    $[72] = t40;
  } else {
    t40 = $[72];
  }
  let t41;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div itemProp="brand" itemScope={true} itemType="https://schema.org/Brand"><meta itemProp="name" content="Carry" /></div>;
    $[73] = t41;
  } else {
    t41 = $[73];
  }
  let t42;
  if ($[74] !== product.combinations) {
    t42 = product.combinations?.values?.[0]?.attributes?.Rozmiar && <meta itemProp="size" content={product.combinations.values[0].attributes.Rozmiar} />;
    $[74] = product.combinations;
    $[75] = t42;
  } else {
    t42 = $[75];
  }
  let t43;
  if ($[76] !== product.idProductAttribute) {
    t43 = product.idProductAttribute && <meta itemProp="additionalProperty" content={`Product Attribute ID: ${product.idProductAttribute}`} />;
    $[76] = product.idProductAttribute;
    $[77] = t43;
  } else {
    t43 = $[77];
  }
  const t44 = product;
  const t45 = hasInitialProductLoaded && loadingProduct;
  let t46;
  if ($[78] !== getProductData || $[79] !== pathname) {
    t46 = reference_0 => {
      getProductData(reference_0).then(() => {
        const previousReference = extractReferenceFromUrl(pathname);
        if (previousReference) {
          window.history.replaceState(null, "", pathname.replace(previousReference, reference_0));
        }
      });
    };
    $[78] = getProductData;
    $[79] = pathname;
    $[80] = t46;
  } else {
    t46 = $[80];
  }
  const t47 = product.parentCategory?.name || "";
  const t48 = product.parentCategory?.linkRewrite || "";
  let t49;
  if ($[81] !== t47 || $[82] !== t48) {
    t49 = {
      name: t47,
      linkRewrite: t48
    };
    $[81] = t47;
    $[82] = t48;
    $[83] = t49;
  } else {
    t49 = $[83];
  }
  let t50;
  if ($[84] !== clearSearch) {
    t50 = () => {
      setOpenShopAvailabilityDrawer(false);
      clearSearch();
    };
    $[84] = clearSearch;
    $[85] = t50;
  } else {
    t50 = $[85];
  }
  let t51;
  if ($[86] !== attributes || $[87] !== clearSearch || $[88] !== combinations || $[89] !== searchAvailabilityFunc || $[90] !== searchAvailabilityLoading || $[91] !== searchedAvailability || $[92] !== searchedShops || $[93] !== selectColor || $[94] !== selectSize || $[95] !== selectedColor || $[96] !== selectedReference || $[97] !== selectedSize || $[98] !== t50) {
    t51 = <ShopAvailabilityDrawer combinations={combinations} attributes={attributes} selectedColor={selectedColor} selectedSize={selectedSize} searchedAvailability={searchedAvailability} searchedShops={searchedShops} selectedReference={selectedReference} searchAvailabilityFunc={searchAvailabilityFunc} clearSearch={clearSearch} selectColor={selectColor} selectSize={selectSize} closeDrawer={t50} searchAvailabilityLoading={searchAvailabilityLoading} />;
    $[86] = attributes;
    $[87] = clearSearch;
    $[88] = combinations;
    $[89] = searchAvailabilityFunc;
    $[90] = searchAvailabilityLoading;
    $[91] = searchedAvailability;
    $[92] = searchedShops;
    $[93] = selectColor;
    $[94] = selectSize;
    $[95] = selectedColor;
    $[96] = selectedReference;
    $[97] = selectedSize;
    $[98] = t50;
    $[99] = t51;
  } else {
    t51 = $[99];
  }
  let t52;
  if ($[100] !== product.reference || $[101] !== product.sizeTable) {
    t52 = product.sizeTable ? <SizeTableDrawer sizeTableContent={product.sizeTable.sizeTableContent || ""} topText={product.sizeTable.topText || false} bottomText={product.sizeTable.bottomText || false} productReference={product.reference} setOpenSizeTableDrawer={setOpenSizeTableDrawer} /> : null;
    $[100] = product.reference;
    $[101] = product.sizeTable;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] !== accessories || $[104] !== addedProduct || $[105] !== featuredProducts || $[106] !== loadingFeaturedProducts || $[107] !== loadingProduct || $[108] !== openShopAvailabilityDrawer || $[109] !== openSizeTableDrawer || $[110] !== openUpdateCartModal || $[111] !== t44 || $[112] !== t45 || $[113] !== t46 || $[114] !== t49 || $[115] !== t51 || $[116] !== t52 || $[117] !== toggleUpdateCartModal || $[118] !== updateCartWithGTM) {
    t53 = <ProductPageComponent product={t44} isProductLoading={t45} getProductData={t46} updateCart={updateCartWithGTM} openUpdateCartModal={openUpdateCartModal} toggleUpdateCartModal={toggleUpdateCartModal} addedProduct={addedProduct} parentCategory={t49} shopAvailabilityDrawer={t51} openShopAvailabilityDrawer={openShopAvailabilityDrawer} setOpenShopAvailabilityDrawer={setOpenShopAvailabilityDrawer} sizeTableDrawer={t52} openSizeTableDrawer={openSizeTableDrawer} setOpenSizeTableDrawer={setOpenSizeTableDrawer} accessories={accessories} loadingAccessories={loadingProduct} featuredProducts={featuredProducts} loadingFeaturedProducts={loadingFeaturedProducts} />;
    $[103] = accessories;
    $[104] = addedProduct;
    $[105] = featuredProducts;
    $[106] = loadingFeaturedProducts;
    $[107] = loadingProduct;
    $[108] = openShopAvailabilityDrawer;
    $[109] = openSizeTableDrawer;
    $[110] = openUpdateCartModal;
    $[111] = t44;
    $[112] = t45;
    $[113] = t46;
    $[114] = t49;
    $[115] = t51;
    $[116] = t52;
    $[117] = toggleUpdateCartModal;
    $[118] = updateCartWithGTM;
    $[119] = t53;
  } else {
    t53 = $[119];
  }
  let t54;
  if ($[120] !== t15 || $[121] !== t17 || $[122] !== t18 || $[123] !== t19 || $[124] !== t21 || $[125] !== t23 || $[126] !== t24 || $[127] !== t25 || $[128] !== t26 || $[129] !== t27 || $[130] !== t28 || $[131] !== t40 || $[132] !== t42 || $[133] !== t43 || $[134] !== t53) {
    t54 = <div itemScope={true} itemType="https://schema.org/Product">{t15}{t17}{t18}{t19}{t21}{t23}{t24}{t25}{t26}{t27}{t28}{t40}{t41}{t42}{t43}{t53}</div>;
    $[120] = t15;
    $[121] = t17;
    $[122] = t18;
    $[123] = t19;
    $[124] = t21;
    $[125] = t23;
    $[126] = t24;
    $[127] = t25;
    $[128] = t26;
    $[129] = t27;
    $[130] = t28;
    $[131] = t40;
    $[132] = t42;
    $[133] = t43;
    $[134] = t53;
    $[135] = t54;
  } else {
    t54 = $[135];
  }
  return t54;
}
function _temp(url) {
  if (/([A-Z]{2}-[A-Z0-9]{1,2}-[0-9]{3})(?:\/?)$/.test(url)) {
    return url.match(/([A-Z]{2}-[A-Z0-9]{1,2}-[0-9]{3})(?:\/?)$/)?.[1];
  }
  return null;
}